import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box } from "@gemini/core";
import { Card } from "@gemini/ui";
import { Section, Title } from "@/components/UI";
import { DsaElement } from "@/components";
export const PartnerBoxWrapper = ({ title, children, partnerBoxRef, }) => {
    return (_jsxs(Section, { ref: partnerBoxRef, unsafeClassname: "HideOnPrint", children: [_jsxs(Box, { display: "flex", justifyContent: "space-between", marginBottom: "spacing.24", children: [_jsx(Title, { hasMargin: false, variant: "section", title: title }), _jsx(DsaElement, {})] }), _jsx(Card, { borderRadius: "8", hasPadding: false, children: children })] }));
};
